import React, { memo, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, EchartsWithTheme, Empty, Tooltip, useTheme } from '@maxtropy/components';
import {
  apiV2EnergyOverviewGetAlarmLabelCountPost,
  V2EnergyOverviewGetAlarmLevelCountPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';
import { AlarmLevel } from '../../../../const';
import { usePieAutoLoop } from '../AlarmArea/hook';
import { Spin } from 'antd';
import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { getPieChartOption } from './chart';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import { isEmpty } from 'lodash-es';
import { IndexTimeActive } from '../../../LeftBox/components/SwitchDate';
import titlePng from '@/assets/images/title_icon.png';
import Marquee from './marquee';
import { keepOneOrLine } from '@/utils/utils';

export const Colors = [
  '#52E7FF',
  '#FF477B',
  '#FFCB47',
  '#6F47FF',
  '#16DD8E',
  '#2D8DFF',
  '#52C41A',
  '#234ED9',
  '#FF9247',
  '#854ECA',
  '#4A90E2',
  '#FF4D4F',
  '#59D744',
  '#5D7092',
];

export interface PieLegendProp {
  name: string;
  level: AlarmLevel;
  color: string;
  data: V2EnergyOverviewGetAlarmLevelCountPostResponse['highLevel'];
}

const AlarmType = () => {
  const theme = useTheme();
  const { timeResolution, dateValue } = useContext(ShareDataUnityEnergyCockpitMapContext);
  const [typePieLegendData, setTypePieLegendData] = useState<PieLegendProp[]>();

  const typeChartRef = useRef(null);

  // usePieAutoLoop(typeChartRef, {
  //   length: typePieLegendData?.length ?? 0,
  // });

  // 统计等级统计
  const { data, loading } = useRequest(
    async () => {
      return await apiV2EnergyOverviewGetAlarmLabelCountPost({
        timeResolution,
        fromTime: getDefaultTime(timeResolution!, dateValue)?.startTime,
        toTime: getDefaultTime(timeResolution!, dateValue)?.endTime,
      });
    },
    {
      refreshDeps: [timeResolution, dateValue],
      ready: !!timeResolution && !!dateValue,
    }
  );

  useEffect(() => {
    setTypePieLegendData(
      data?.alarmLabelCountDetails?.map((item, index) => ({
        name: item.labelName!,
        level: index,
        data: { total: item.total, proportion: item.proportion },
        color: Colors[index],
      }))
    );
  }, [data]);

  const chartPieOption = useMemo(() => {
    return getPieChartOption(
      data?.alarmLabelCountDetails?.reduce((acc, cur) => acc + (cur.total ?? 0), 0) ?? 0,
      typePieLegendData
    );
  }, [data, typePieLegendData]);

  return (
    <SubTitle
      title={
        <span>
          报警类型
          <Button
            type="link"
            style={{ padding: '0 20px' }}
            onClick={() => {
              window.open(
                `/alarm/record/analysis?resolution=${timeResolution === IndexTimeActive.THIS_MONTH ? 'D' : 'M'}`
              );
            }}
          >
            详情{'>>'}
          </Button>
        </span>
      }
      img={titlePng}
    >
      <Spin spinning={loading}>
        <div className={styles.pie_wrapper}>
          <div className={styles.chart_wrapper}>
            <EchartsWithTheme
              ref={typeChartRef}
              empty={{
                isShowEmpty: isEmpty(data?.alarmLabelCountDetails),
                emptyNode: <Empty />,
              }}
              theme={theme}
              type="pie"
              style={{ height: 120, width: 120 }}
              option={chartPieOption}
            />
          </div>
          <div className={styles.customer_legend}>
            {(typePieLegendData ?? []).map(item => (
              <div className={styles.legend_item} key={item.name}>
                <div className={styles.icon} style={{ backgroundColor: item.color }}></div>
                <Marquee>{item.name ?? '-'}</Marquee>
                <div className={styles.value}>{item.data?.total || '-'}</div>
                <div className={styles.proportion}>{keepOneOrLine(Number(item.data?.proportion))}%</div>
              </div>
            ))}
          </div>
        </div>
      </Spin>
    </SubTitle>
  );
};

export default AlarmType;
